<template>
    <div class="loader-container">
        <div class="loader-text">
            <p>{{ upperText }}</p>
            <p>{{ lowerText }}</p>
            <div>
                <common-icon :class="iconClass" :name="icon" :size="getIconSize"></common-icon>
            </div>
        </div>
    </div>
</template>

<script>
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [ScreenSizeDetectionMixin],
        props: {
            upperText: { type: String, default: '' },
            lowerText: { type: String, default: '' },
            icon: { type: String, default: 'chains' },
            iconClass: { type: String, default: 'glowing' },
        },

        computed: {
            getIconSize() {
                return this.isMobileLarge ? 'gigantic' : 'extra-gigantic'
            },
        },
    }
</script>
